<mat-card class="contact-card">
    <mat-card-header>
        Verify and save uploaded data
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="form">
            <div class="card-grid" >
                <!-- Row 1 -->
                <div class="row1" formGroupName="contact">
                    <mat-form-field appearance="outline">
                        <mat-label>First name</mat-label>
                        <input matInput formControlName="firstName">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Last name</mat-label>
                        <input matInput formControlName="lastName">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email">
                    </mat-form-field>
                </div>

                <!-- Row 2 -->
                <div class="row2">
                    <mat-form-field appearance="outline">
                        <mat-label>Position</mat-label>
                        <input matInput formControlName="position">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Organisation</mat-label>
                        <input matInput formControlName="organisation">
                    </mat-form-field>
                </div>

                <!-- Row 3 -->
                <div class="row3">
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Stakeholder groups</mat-label>
                        <app-advanced-chip-select #stakeholderGroupsSelect placeholder="Add group..."
                            [allOptions]="allStakeholderGroupOptions()" formControlName="stakeholderGroups"
                            [required]="true" />
                        @if (form.get('stakeholderGroups')?.hasError('required')) {}
                        <mat-error>At least one stakeholder group must be selected</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Topics of interest</mat-label>
                        <app-advanced-chip-select #topicsSelect placeholder="Add topic..."
                            [allOptions]="allTopicOptions()" formControlName="topicsOfInterest" />
                    </mat-form-field>
                </div>

                <!-- Right column -->
                <div class="info">
                    <div class="info">
                        @if (matchingContacts().length > 0) {
                        <div class="n-info-item">
                            <span class="material-symbols-outlined n-warning-icon">warning</span>
                            <span class="mat-body-small n-warning-text">
                                {{ matchingContacts().length }} matching contact(s) found.
                            </span>
                        </div>
                        <mat-radio-group aria-label="Select an option" class="n-warning-options"
                            formControlName="contactSelect">
                            <mat-radio-button class="n-warning-radio" value="new">Create new contact
                            </mat-radio-button>
                            @for (c of matchingContacts(); track c.id) {
                            <div style="display: flex; gap: 2px; align-items: center;">
                                <mat-radio-button class="n-warning-radio" [value]="c.id.toString()">Use
                                    <i>{{c.firstName}}
                                        {{c.lastName | uppercase}}
                                        {{c.email}}</i>
                                </mat-radio-button>
                                <a href="{{ c.id | urlMaker:'contact'}}" target="_blank" class="n-warning-link"><span
                                        class="material-symbols-outlined">open_in_new</span></a>

                            </div>
                            }
                        </mat-radio-group>
                        } @else {
                        <mat-radio-group aria-label="Select an option" class="n-info-options"
                            formControlName="contactSelect">
                            <mat-radio-button class="n-info-radio" value="new">Create new contact
                            </mat-radio-button>
                        </mat-radio-group>
                        }
                        @if (matchingOrganisations().length > 0 ){
                        <div class="n-info-item">
                            <span class="material-symbols-outlined n-warning-icon">warning</span>
                            <span class="mat-body-small n-warning-text">
                                Existing organisation found.
                            </span>
                        </div>
                        <mat-radio-group aria-label="Select an option" class="n-warning-options"
                            formControlName="organisationSelect">
                            <mat-radio-button class="n-warning-radio" value="new">Create new organisation
                            </mat-radio-button>
                            @for (o of matchingOrganisations(); track o.id) {
                            <div style="display: flex; gap: 2px; align-items: center;">
                                <mat-radio-button class="n-warning-radio" [value]="o.id.toString()">Use
                                    <i>{{o.name}}</i></mat-radio-button>
                                <a href="{{ o.id | urlMaker:'organisation'}}" target="_blank"
                                    class="n-warning-link"><span
                                        class="material-symbols-outlined">open_in_new</span></a>
                            </div>
                            }
                        </mat-radio-group>
                        } @else {
                        <mat-radio-group aria-label="Select an option" class="n-info-options"
                            formControlName="organisationSelect">
                            <mat-radio-button class="n-info-radio" value="new">Create new organisation
                            </mat-radio-button>
                        </mat-radio-group>
                        }
                        @if (importItem().invalidStakeholderGroups.length > 0) {
                        <div class="n-info-item">
                            <span class="material-symbols-outlined n-warning-icon">warning</span>
                            <span class="mat-body-small n-warning-text">
                                Invalid stakeholder groups:
                                {{ importItem().invalidStakeholderGroups.join(", ") }}.
                            </span>
                        </div>
                        }
                        @if (importItem().invalidTopicsOfInterest.length > 0) {
                        <div class="n-info-item">
                            <span class="material-symbols-outlined n-warning-icon">warning</span>
                            <span class="mat-body-small n-warning-text">
                                Invalid topics of interest:
                                {{ importItem().invalidTopicsOfInterest.join(", ") }}.
                            </span>
                        </div>
                        }
                    </div>
                </div>
            </div>

            <mat-card-actions
                style="display: flex; flex-direction: row; gap: 5px; width: 100%; justify-content: flex-end;">
                <button mat-icon-button matTooltip="save row" class="n-save-button" (click)="save()" [disabled]="form.invalid">
                    <span class=" material-symbols-outlined"> save </span>
                </button>
                <button mat-icon-button matTooltip="reload row from uploaded data" class="n-export-button"
                    (click)="refresh()">
                    <span class="material-symbols-outlined"> refresh </span>
                </button>
                <button mat-icon-button matTooltip="delete row's uploaded data" class="n-delete-button"
                    (click)="delete()">
                    <span class="material-symbols-outlined"> delete </span>
                </button>
            </mat-card-actions>
        </form>
    </mat-card-content>
</mat-card>